"use client";

import React from 'react';

interface LogoProps {
  size?: 'sm' | 'md' | 'lg';
  className?: string;
}

const Logo = ({ size = 'md', className = "" }: LogoProps) => {
  const dimensions = {
    sm: "w-10 h-10",
    md: "w-14 h-14",
    lg: "w-20 h-20"
  };

  const textSizes = {
    sm: "text-xs",
    md: "text-sm",
    lg: "text-xl"
  };

  return (
    <div className={`relative flex items-center justify-center ${dimensions[size]} ${className}`}>
      {/* Outer Ring */}
      <div className="absolute inset-0 border border-fuchsia-500/20 rounded-full animate-[spin_10s_linear_infinite]" />
      
      {/* Middle Dashed Ring */}
      <div className="absolute inset-1 border border-dashed border-fuchsia-500/40 rounded-full animate-[spin_15s_linear_infinite_reverse]" />
      
      {/* Inner Solid Ring */}
      <div className="absolute inset-2 border-2 border-fuchsia-500/60 rounded-full animate-[pulse_3s_ease-in-out_infinite]" />
      
      {/* Glow Effect */}
      <div className="absolute inset-0 bg-fuchsia-500/10 blur-xl rounded-full" />
      
      {/* The Initials */}
      <div className={`${textSizes[size]} font-black text-fuchsia-500 drop-shadow-[0_0_10px_rgba(217,70,239,0.8)] select-none z-10 tracking-tighter`}>
        HS
      </div>
    </div>
  );
};

export default Logo;